import React from "react";
import { Icon } from "@focus/focusUI";
import { useNavigate, useParams } from "react-router-dom";
import { ContentHeader } from "../ContentHeader";
import { useCatalogue } from "../../hooks/useCatalogue";
import { CatalogObjectDetails } from "./CatalogObjectDetails";

export const CatalogObjectInformation = () => {
  const { object, getCatalogueObjectInfo } = useCatalogue();
  const navigate = useNavigate();
  const params = useParams();

  React.useEffect(() => {
    if (params.id) {
      getCatalogueObjectInfo(params.id);
    }
  }, [params.id]);

  return (
    <div className="foc-content flex flex-col overflow-hidden">
      <ContentHeader
        renderCustomTitle={() => (
          <button
            className="-ml-1 inline-flex w-fit cursor-pointer appearance-none items-center gap-1 rounded-md border-0 bg-transparent px-1.5 py-1 text-sm font-semibold text-slate-500 transition hover:bg-slate-100 hover:text-slate-800"
            onClick={() => navigate(-1)}
            type="button"
          >
            <Icon icon="chevron-left" size={14} />
            Back
          </button>
        )}
      />
      <div className="foc-table-container flex min-h-0 flex-1 overflow-hidden">
        <CatalogObjectDetails object={object} />
      </div>
    </div>
  );
};
